<div
	class="rx-banner-container"
	[class]="type"
	[class.rx-banner-container--intuitive]="isIntuitiveAppearance"
>
	<div class="banner-message">{{ message }}</div>
</div>
